var firebaseConfig = {
    apiKey: "AIzaSyA9ACtzlrRSr-3zDrWLNIzO2bxPO4DzXJs",
    authDomain: "dhaka-wheels.firebaseapp.com",
    projectId: "dhaka-wheels",
    storageBucket: "dhaka-wheels.appspot.com",
    messagingSenderId: "206722886518",
    appId: "1:206722886518:web:31387b060328ec888a2857"
  };

  export default firebaseConfig;